import React from "react";
import { Salad, Leaf, BadgeCheck, MapPin, MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { SPYZZIE_HERO, SPYZZIE_DISHES, CONTACT } from "../mock";

const FEATURES = [
  { icon: Salad, text: "Fresh, healthy & hot homemade food by Chef Lisha Anand" },
  { icon: Leaf, text: "100% biodegradable, eco-friendly packaging \u2014 no plastic" },
  { icon: BadgeCheck, text: "GST registered & FSSAI certified kitchen" },
];

const SpyzzzApp = () => (
  <section id="app" className="py-20 md:py-28 bg-white">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="rounded-3xl bg-neutral-50 overflow-hidden shadow-sm grid lg:grid-cols-2 items-center">
        {/* Left: food image */}
        <div className="relative h-64 lg:h-full min-h-[320px]">
          <img
            src={SPYZZIE_HERO}
            alt="Spyzzie homemade food delivery in Munnar"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute top-4 left-4 flex gap-2">
            {SPYZZIE_DISHES.map((d) => (
              <span
                key={d.name}
                className="bg-white/95 backdrop-blur text-[11px] font-semibold text-neutral-800 rounded-full px-3 py-1 shadow"
              >
                {d.name} · {d.price}
              </span>
            ))}
          </div>
        </div>

        {/* Right: content */}
        <div className="p-8 md:p-14">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#e8542a] mb-4">
            Our Online App · Food Delivery
          </p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-neutral-900 mb-2 leading-tight">
            Spyzzie
          </h2>
          <p className="text-lg font-semibold text-neutral-700 mb-5">
            Hot Food. Fast Delivery. Munnar &amp; Beyond.
          </p>
          <p className="text-neutral-600 leading-8 mb-7">
            Spyzzie is the food delivery service of Auracrest Haven — fresh, healthy homemade
            food delivered to your home, resort, homestay or even a parking lot. Order online, pay
            via UPI, and confirm on WhatsApp. Ready in about 20 minutes, delivered daily 11AM&ndash;9PM.
          </p>

          <ul className="space-y-4 mb-8">
            {FEATURES.map((f, i) => (
              <li key={i} className="flex items-center gap-3">
                <span className="w-10 h-10 shrink-0 rounded-xl bg-[#fdeae2] flex items-center justify-center">
                  <f.icon className="w-5 h-5 text-[#e8542a]" />
                </span>
                <span className="text-neutral-700">{f.text}</span>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2 text-sm text-neutral-500 mb-6">
            <MapPin className="w-4 h-4 text-[#e8542a]" />
            Delivering across Anachal, Sengulam, ET City, Bison Valley, Vellathooval &amp; 20+ areas
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://spyzzie.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#e8542a] hover:bg-[#cf4620] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors"
            >
              Order Now <ArrowUpRight className="w-5 h-5" />
            </a>
            <a
              href={`https://wa.me/919388881016`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#e8542a] text-[#e8542a] hover:bg-[#fdeae2] font-semibold px-7 py-3.5 rounded-lg transition-colors"
            >
              <MessageCircle className="w-5 h-5" /> WhatsApp Order
            </a>
          </div>

          <p className="text-sm text-neutral-500 mt-5">
            Visit{" "}
            <a
              href="https://spyzzie.in"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-[#e8542a] hover:underline"
            >
              spyzzie.in
            </a>{" "}
            to view the full menu, or call{" "}
            <a href={`tel:${CONTACT.phone}`} className="font-medium text-neutral-700">
              {CONTACT.phone}
            </a>
            . Large free parking &mdash; drive in, pick up and save on delivery charges.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default SpyzzzApp;
